import ExcelJS from 'exceljs'

const COLUMNS = [
  { header: '告警時間', key: 'time', width: 20 },
  { header: '案場', key: 'factoryName', width: 18 },
  { header: '逆變器', key: 'inv', width: 8 },
  { header: '串列', key: 'pv', width: 8 },
  { header: '等級', key: 'level', width: 14 },
  { header: '類型', key: 'category', width: 14 },
  { header: '事件', key: 'desc', width: 60 },
  { header: '進行中', key: 'ongoing', width: 8 }
]

// 第一頁「全部」，之後依等級各一頁（順序跟畫面上的嚴重度排序一致）
const alarmSheets = (alarms, sevConfig) => {
  const label = (lv) => sevConfig[lv]?.label ?? `等級${lv}`
  const prio = (lv) => sevConfig[lv]?.priority ?? 99
  const rows = alarms
    .map((a) => ({
      lv: a['等級'],
      time: a['告警啟動時間'],
      factoryName: a.factoryName,
      inv: a.inv ?? '',
      pv: a.pv ?? '',
      level: label(a['等級']),
      category: a['類型'] ?? '',
      desc: a['事件'],
      ongoing: a.ongoing ? '是' : ''
    }))
    .sort((a, b) => b.time.localeCompare(a.time))

  const levels = [...new Set(rows.map((r) => r.lv))].sort((a, b) => prio(a) - prio(b))
  return [
    { name: '全部', rows },
    ...levels.map((lv) => ({ name: label(lv), rows: rows.filter((r) => r.lv === lv) }))
  ]
}

const alarmDownload = async (fileName, alarms, sevConfig) => {
  const workbook = new ExcelJS.Workbook()
  for (const { name, rows } of alarmSheets(alarms, sevConfig)) {
    const sheet = workbook.addWorksheet(name, { views: [{ state: 'frozen', ySplit: 1 }] })
    sheet.columns = COLUMNS
    sheet.addRows(rows)
    sheet.getRow(1).font = { bold: true }
    sheet.autoFilter = { from: 'A1', to: 'H1' }
  }
  const url = window.URL.createObjectURL(new Blob([await workbook.xlsx.writeBuffer()]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}.xlsx`)
  link.click()
  window.URL.revokeObjectURL(url)
}

export { alarmSheets, alarmDownload }
